import classNames from "classnames";
import { Text } from "@zapier/design-system";
import { removeTemplateFromString } from "@zapier/canvas-state";
import { lowercaseExceptFirst } from "../../utils/lowercaseExceptFirst";
import styles from "./TemplateThumbnail.module.css";

type Props = {
  name: string;
  onClick: () => void;
  imageUrl: string;
  imageAltText: string;
  isSelected: boolean;
  isDisabled?: boolean;
};

export function TemplateThumbnail({
  name,
  onClick,
  imageUrl,
  imageAltText,
  isSelected,
  isDisabled,
}: Props) {
  return (
    <button
      className={classNames(styles.wrapper, {
        [styles.selected]: isSelected,
      })}
      disabled={isDisabled}
      onClick={onClick}
    >
      <img
        src={imageUrl}
        alt={imageAltText}
        className={styles.imageContainer}
      />
      <div className={styles.textWrapper}>
        <div className={styles.title}>
          <Text type="SmallPrint3Multiline" color="TextDefault">
            {lowercaseExceptFirst(removeTemplateFromString(name))}
          </Text>
        </div>
      </div>
    </button>
  );
}
